import { LegalPage } from "./Legal";

export function Terms() {
  return <LegalPage page="terms" />;
}
